import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { userKey } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import envVars from '../../../constants/envVars';
const useRevokeUserTokens = () => {
    const queryClient = useQueryClient();
    const params = useQueryRequestParams();
    return useMutation({
        mutationFn: (attributes) => axios.post(`${envVars.API_CLOUD_HOSTNAME}backoffice/revoke-user-tokens/`, { ...attributes }, params),
        onSuccess: (_, vars) => {
            queryClient.invalidateQueries({ queryKey: [userKey, vars.hero_user_id] });
        }
    });
};
export default useRevokeUserTokens;
